import type { nonEmptyBooking } from "@calcom/features/experts/lib/getBookingPropsForExpersIds";
import BookingWidget from "./BookingWidget";
import notEmpty from "@calcom/lib/notEmpty";

type BookingProps = { booking: nonEmptyBooking | { notFound: boolean } | null } & {
  userList?: string[];
};

export const BookingSection = ({ booking, userList }: BookingProps) => {
  if (!booking || "notFound" in booking) return null;

  if ("eventType" in booking) {
    const usersExists = booking.eventType.users;
    const usersNames =
      userList || (usersExists ? booking.eventType.users.map((user) => user.username).filter(notEmpty) : []);

    if (!Boolean(usersNames.length)) return null;

    return (
      <div className="bg-brand-50" id="book-now">
        <div className="container flex flex-col gap-10 py-12 md:grid md:grid-cols-12 md:py-32">
          <div className="col-span-12 max-w-2xl xl:col-span-4">
            <h2 className="text-4xl md:text-5xl"> Book a slot</h2>
            <p className="mt-4 text-xl leading-normal">
              Use our expert as an “extra brain” to help you strategise, execute and assess the result.
            </p>
          </div>
          <div className="col-span-12 text-xl leading-normal xl:col-span-7 xl:col-start-6">
            <BookingWidget {...booking} userList={usersNames} />
          </div>
        </div>
      </div>
    );
  }
  return null;
};
